export default __webpack_public_path__ + "static/prepare-teach-analyse-d8e57a33f8d14133b644c195a3b0559c.mp4";